import { render } from "./ManageMembersModal.vue?vue&type=template&id=36230b70&scoped=true"
import script from "./ManageMembersModal.vue?vue&type=script&lang=js"
export * from "./ManageMembersModal.vue?vue&type=script&lang=js"

import "./ManageMembersModal.vue?vue&type=style&index=0&id=36230b70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36230b70"]])

export default __exports__